<template>
  <van-row>
    <van-nav-bar :title="Data.name"/>
    <van-col span="24">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in imglist" :key="item" style="display: block">
          <van-image :src="imgPrefix + item"/>
        </van-swipe-item>
      </van-swipe>
    </van-col>
    <van-col span="24">
      <van-grid :column-num="2">
        <van-grid-item @click="downloadApp" v-for="item in list" :key="item.id" class="vant-item">
          <van-image v-if="item.activityImage" :src="imgPrefix + item.activityImage"/>
          <van-image v-else :src="imgPrefix + item.productIcon"/>
          <p>{{ item.productName }}</p>
          <p>
            <span>￥{{ item.promotionPrice }}</span>
            <small>预估到手价</small>
            <span>{{ item.originalPrice }}</span>
          </p>
        </van-grid-item>
      </van-grid>
    </van-col>
    <!-- <button id="downloadButton">按钮</button> -->
  </van-row>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      Data: {},
      imglist: [],
      imgPrefix: "http://qiniu.xzypapp.com/",
      isIos: false,
      isAndroid: false,
      schemeUrl: "",
      downloadUrl: "http://qr15.cn/F6fhRD",
      id: 725,
    };
  },

  mounted() {
    this.getActivity();
    this.onisIOS();
    this.axios({
      method: "post",
      url: "api/user/setSmsCount",
      data: {},
    }).then(res => {});
    // const s = document.createElement("script");
    // s.type = "text/javascript";
    // s.src = "//web.cdn.openinstall.io/openinstall.js";
    // s.addEventListener(
    //   "load",
    //   () => {
    //     var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
    //     console.log(data);
    //     new OpenInstall(
    //       {
    //         /*appKey必选参数，openinstall平台为每个应用分配的ID*/
    //         appKey: "b6dlas",
    //         /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
    //         //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
    //         /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
    //         //preferWakeup:true,
    //         /*自定义遮罩的html*/
    //         //mask:function(){
    //         //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
    //         //},
    //         /*openinstall初始化完成的回调函数，可选*/
    //         onready: function () {
    //           var m = this,
    //             button = document.getElementById("downloadButton");
    //           button.style.visibility = "visible";

    //           /*在app已安装的情况尝试拉起app*/
    //           m.schemeWakeup();
    //           /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
    //           button.onclick = function () {
    //             m.wakeupOrInstall();
    //             return false;
    //           };
    //         },
    //       },
    //       data
    //     );
    //   },
    //   false
    // );
    // document.head.appendChild(s);
  },
  methods: {
    onisIOS() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        this.isAndroid = true;
        this.schemeUrl = "xzyp://com.xzyp.app";
        this.downloadUrl = "http://qr15.cn/F6fhRD";
      }
      if (isIOS) {
        this.isIos = true;
        this.schemeUrl = "tencent101482537://";
        this.downloadUrl = "http://qr15.cn/F6fhRD";
      }
    },
    getActivity() {
      this.axios({
        method: "post",
        url: "api/activity/get",
        data: {
          id: this.id,
        },
      }).then(res => {
        if (res.data.code == 200) {
          this.Data = res.data.data;
          this.imglist = this.Data.images.split("|");
        }
      });
      this.axios({
        method: "post",
        url: "api/goods/findOneLimitActivityGoodsByActivityId",
        data: {
          activityId: this.id,
          pageable: {
            page: 1,
            size: 60,
          },
        },
      }).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
        }
      });
    },

    downloadApp() {
      if (!this.isBlackApp()) {
        this.openTuer();
      } else {
        //显示手动打开外置浏览器提示
        this.$toast("请在右上角选择默认浏览器打开");
      }
    },
    isBlackApp() {
      var u = navigator.userAgent.toLowerCase();
      return (
        /micromessenger/i.test(u) ||
        u.indexOf("weibo") > -1 ||
        u.indexOf("qq") > -1 ||
        u.indexOf("mqqbrowser") > -1
      );
    },
    // 点击打开app
    openTuer() {
      this.jumpApp(this.schemeUrl);
      this.noApp();
    },
    // 跳转打开app
    jumpApp(t) {
      console.log(t);
      try {
        var e = navigator.userAgent.toLowerCase(),
          n = e.match(/cpu iphone os (.*?) like mac os/);
        if (
          ((n = null !== n ? n[1].replace(/_/g, ".") : 0), parseInt(n) >= 9)
        ) {
          window.location.href = t;
        } else {
          var r = document.createElement("iframe");
          (r.src = t), (r.style.display = "none"), document.body.appendChild(r);
        }
      } catch (e) {
        window.location.href = t;
      }
    },
    // 无响应或者没安装跳转下载
    noApp() {
      var t = Date.now(),
        r = this.downloadUrl;
      console.log(r);
      this.timer = setTimeout(function() {
        return Date.now() - t > 2200
          ? (clearTimeout(this.timer), !1)
          : !document.webkitHidden &&
              !document.hidden &&
              void (location.href = r);
      }, 2000);
    },
  },
};
</script>
<style lang="less" scoped>
.van-nav-bar {
  background-image: linear-gradient(to right, #f09852, #ec6637, #ea3e26);
  /deep/.van-nav-bar__title {
    color: #fff;
    font-weight: 600;
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
}
.vant-item {
  .van-image {
    margin-bottom: 5px;
  }
  p {
    font-size: 0.75rem;
    width: 100%;
    text-align: left;
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
      display: flex;
      align-items: center;
      small {
        flex: 1;
        margin-left: 0.1875rem;
        font-size: 0.75rem;
      }
      span {
        color: red;
        font-size: 1rem;
        font-weight: 600;
        &:last-child {
          text-decoration: line-through;
          font-size: 0.75rem;
          color: #999;
          text-align: right;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity.vue